/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AIAgentsObservabilityListTracesRequest {
    getFixupPrototypeFunction() { return AIAgentsObservabilityListTracesRequest.fixupPrototype; }

    static newInstance(model: Partial<AIAgentsObservabilityListTracesRequest>): AIAgentsObservabilityListTracesRequest {
        let obj = Object.assign(new AIAgentsObservabilityListTracesRequest(), model);
        AIAgentsObservabilityListTracesRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AIAgentsObservabilityListTracesRequest>): AIAgentsObservabilityListTracesRequest {
        if (!model) return null;
        return AIAgentsObservabilityListTracesRequest.newInstance(<AIAgentsObservabilityListTracesRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AIAgentsObservabilityListTracesRequest) {
        if (!obj) return;

        models.AIAgentsObservabilityListTracesRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AIAgentsObservabilityListTracesRequest): boolean {
        Object.setPrototypeOf(obj, AIAgentsObservabilityListTracesRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.list_context) {
            models.ListContext.fixupPrototype(this.list_context);
        }
        if (this.filters) {
            models.AIAgentTracesFilter.fixupPrototype(this.filters);
        }
        if (this.sort) {
            for (let val of this.sort) {
                models.AIAgentTracesSortCriteria.fixupPrototype(val);
            }
        }
    }

    /**
     * Optional list context
     */
    list_context: models.ListContext;

    /**
     * Sort criteria
     */
    sort: Array<models.AIAgentTracesSortCriteria>;

    /**
     * Filters for the request
     */
    filters: models.AIAgentTracesFilter;

}
